import { persist } from './api-client';

export async function persistQwantum(_id, qwantumId, value, backup = false) {
  try {
    // Use the API client persist function
    const delta = { [qwantumId]: value };
    await persist(delta, _id, null, null, backup);
  } catch (error) {
    console.error("Error persisting Qwantum:", error);
    throw error; // Rethrow for higher-level handling.
  }
}